import {useTranslation} from "react-i18next";
import PageWrapper from "../../components/PageWrapper";
import RoundedTable from "../../components/table-component/RoundedTable";
import {useEffect, useState} from "react";
import {TABLE_CELL_TYPES_LISTED} from "../../components/table-component/ListedTable";
import CustomButton from "../../components/CustomButton";

// Assets

// components
import CustomInput from "../../components/CustomInput";
import Modal from "../../components/Modal";
import SearchFilter from "../../components/SearchFilter";
import CreateForeginBankModal from "./CreateForeginBankModal";
import {getBanksForBank} from "../../services/bank/banksForBank";
import {set} from "date-fns";
import Loader from "../../components/Loader";
import UpdateForeignBankModal from "./UpdateForeignBankModal";
import InformationBox from "../../components/InformationBox";

const ForeignBanks = () => {
    // HOOKS
    const {t} = useTranslation("general");

    // STATES
    const [loading, setLoading] = useState(false);
    const [addBankModal, setAddBankModal] = useState(false);
    const [bankInfoModal, setBankInfoModal] = useState(false);
    const [selectedBank, setSelectedBank] = useState(null); // Add selected bank state
    const [rows, setRows] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [pagination, setPagination] = useState({
        currentPage: 1, limit: 10, totalRecords: 0,
    });
    const [reFetch, setReFetch] = useState(false);
    const [selectedTitle, setSelectedTitle] = useState({
        title: t("bankName"), value: "name",
    });

    // CONSTANTS
    const tableTitles = [{
        value: "bankName",
    }, {
        value: "country", keepOnMobile: true,
    }, {
        value: "address", keepOnMobile: true,
    }, {
        value: "phoneNumber", keepOnMobile: true,
    }, {
        value: "Actions", keepOnMobile: true,
    },];

    const searchTitles = [{
        title: t("bankName"), value: "name",
    }, {
        title: t("country"), value: "country",
    },];

    // Handlers
    const handleEditBank = (bankData) => {
        setSelectedBank(bankData);
        setBankInfoModal(true);
    };

    const fetchBanksOfBanks = async () => {
        try {
            setLoading(true);

            const params = {
                search: searchQuery || undefined,
                searchBy: selectedTitle.value || undefined,
                limit: pagination.limit || 10,
                page: pagination.currentPage || 1,
            };
            const response = await getBanksForBank(params);
            if (response.status === 200) {
                const formatedData = response.data.bankForBanks.map((item) => {
                    return [{
                        type: TABLE_CELL_TYPES_LISTED.TEXT, value: item.name, keepOnMobile: true,
                    }, {
                        type: TABLE_CELL_TYPES_LISTED.TEXT, value: item.country, keepOnMobile: true,
                    }, {
                        type: TABLE_CELL_TYPES_LISTED.TEXT, value: item.address, keepOnMobile: true,
                    }, {
                        type: TABLE_CELL_TYPES_LISTED.TEXT, value: item.phoneNumber, keepOnMobile: true,
                    }, {
                        type: TABLE_CELL_TYPES_LISTED.ELEMENT, value: (<CustomButton
                            title={t("edit")}
                            variant={"blank"}
                            icon='edit'
                            iconSize={18}
                            onClick={() => handleEditBank(item)} // Pass the entire bank object
                        />), keepOnMobile: true,
                    },];
                });

                setRows(formatedData);

                setPagination((prev) => ({
                    ...prev,
                    currentPage: response.data.currentPage,
                    totalPages: response.data.totalPages,
                    totalRecords: response.data.totalRecords,
                }));
            }
        } catch (error) {
            console.error("Error fetching banks:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setBankInfoModal(false);
        setSelectedBank(null);
    };

    const handleBankUpdated = () => {
        // Refresh the banks list after successful update
        fetchBanksOfBanks();
        handleModalClose();
    };

    useEffect(() => {
        fetchBanksOfBanks();
    }, [pagination.currentPage, reFetch]);

    return (<PageWrapper  title={t("foreignBanks")}>
        <section className="o-row o-row--horizontal-align_end u-margin--top_400 u-margin--bottom_400">
            <CustomButton
                title={t("addForeignBank")}
                icon='add'
                iconSize={20}
                onClick={() => setAddBankModal(true)}
            />
        </section>
        <div className="c-search-bar u-margin--bottom_500">
            <section className="c-search-bar-label-input">
                <label>{`${t("search")} ${selectedTitle.title}`}: </label>
                <CustomInput
                    thick
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    resetSearch={() => {
                        setSearchQuery("");
                    }}
                />
            </section>

            <div className="o-row o-row--gap-size_400">
                <SearchFilter
                    options={searchTitles}
                    selected={selectedTitle}
                    setSelected={(selected) => {
                        setSelectedTitle(selected);
                        setSearchQuery("");
                    }}
                    thick
                />
                <CustomButton
                    title={t("search")}
                    icon='search'
                    iconSize={20}
                    onClick={() => fetchBanksOfBanks()}
                />
            </div>
        </div>
        {loading ? (<Loader/>) : (<>
            {rows.length === 0 ? (<InformationBox>{t("noForeignBanks")}</InformationBox>) : (<div>
                <RoundedTable
                    titles={tableTitles}
                    rows={rows} å
                    pagination={pagination}
                    setPagination={setPagination}
                    withRedFlag={false}
                />
            </div>)}
        </>)}

        {bankInfoModal && selectedBank && (<UpdateForeignBankModal
            onClose={handleModalClose}
            bankData={selectedBank}
            onBankUpdated={handleBankUpdated}
        />)}

        {addBankModal && (<CreateForeginBankModal
            onClose={() => {
                setAddBankModal(false);
                setReFetch((prev) => !prev);
            }}
        />)}
    </PageWrapper>);
};

export default ForeignBanks;
